<template>
  <div class="index">
    <div class="indexv-all">
      <div class="index_background">
        <img src="../../assets/m/Index_top_bg.png" />
      </div>
      <div class="banner">
        <div class="title">
          <div class="title1">{{ $t("home.title[0]") }}</div>
          <div class="title1">{{ $t("home.title[1]") }}</div>
          <div class="title1">{{ $t("home.title[2]") }}</div>
        </div>
        <div class="subTitle-all">
          <div class="subTitle">
            <p class="title1">{{ $t("home.Unbelievable") }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="Do_Dao">
      <Do ref="Do"></Do>

      <Dao ref="Dao"></Dao>
    </div>

    <Technical ref="technical"></Technical>
    <!-- 图开始 -->
    <!-- <div class="runDao1">
      <div class="start1">{{ $t("DAO.start1") }}</div>
      <div class="detail">{{ $t("DAO.start2") }}</div>
      <div class="img">
        <img src="../../assets/m/imagea1.png" />
      </div>
    </div> -->
    <!-- 图结束 -->

    <div class="runDao">
      <div class="start">{{ $t("DAO.start") }}</div>
      <div class="bottom">
        <a target="_blank" href="https://www.donetwork.io/doc/">
          <div class="button">
            {{ $t("DAO.build1") }}
          </div>
        </a>
      </div>
    </div>
    <!-- 团队成员 -->
    <!-- <div class="team-member">
      <div class="title-container">
        <div class="title-main">{{ $t("TeamMember.Global") }}</div>
        <div class="title-main">
          {{ $t("TeamMember.distributed") }}
          <span> {{ $t("TeamMember.members") }}</span>
        </div>
      </div>
      <TeamMember></TeamMember>
    </div> -->

    <!--         <Partners ref="partners"></Partners>-->
    <!-- 联系我们开始 -->
    <!-- <div class="runemail">
      <div class="emailcontent">
        <div class="title">Contact Us</div>
        <div><img src="../../assets/pc/email.png" /></div>
        <div class="submit">Submit Feedback</div>
        <div class="email">donetwork@outlook.com</div>
        <div class="content">
          Having trouble using the product?<br />Try asking the support team
          for<br />
          answers
        </div>
      </div>
    </div> -->
    <!-- 联系我们结束 -->
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
// import "swiper/swiper.less";

// import { WOW } from "wowjs";
import Do from "@/views/m/Do.vue";
import Dao from "@/views/m/Dao.vue";
import Technical from "@/views/m/Technical.vue";
// import Partners from '@/views/m/Partners.vue';
import TeamMember from "@/views/m/TeamMember.vue";

// import {
//   Do,
//   Dao,
//   Technical,
//   Partners,
// } from "@/assets/server/api.js";
// import { baseURL, trimHtml } from "@/utils/utils";
// import { setInterval } from "timers";
export default {
  components: {
    Do,
    Dao,
    Technical,
    TeamMember,
    // Partners,
  },
  data() {
    return {};
  },
  computed: {},
  created() {},
  mounted() {
    // window.addEventListener("scroll", this.handleScroll);
    //   this.init();
  },
  destroyed() {
    // window.removeEventListener("scroll", this.handleScroll);
    //   clearInterval(this.timer);
  },
  methods: {
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //  console.log(scrollTop);
      for (var i = 0; i <= 20; i++) {
        console.log(
          document.querySelector(
            "body > div.one-crm-skins > div > div.query-list-wrapper > div.zy-renderer-wrapper > div > div > div.zy-list-content.mb-12 > div.zy-table-wrapper > div > div.customize-table.zy-list-table > div.el-table.el-table--fit.el-table--scrollable-y.el-table--enable-row-transition.el-table--small > div.el-table__fixed > div.el-table__fixed-body-wrapper > table > tbody > tr:nth-child(1) > td.el-table_2_column_25.is-left.customize-table-cell > div > div > button > span"
          ).innerText
        );
      }
      for (var i = 0; i < 5; i++) {
        document.querySelector(
          "body>#pageWrapper > div.container > div.carlist.container-hotcar > div > div > div.carlist-content > div:nth-child(" +
            i +
            ") > h5"
        ).innerText;
      }

      if (scrollTop > 1500) {
        this.indexnum = true;
      } else {
        this.indexnum = false;
      }
    },
  },
};
</script>
<style lang="less">
.runDao1 {
  margin-top: 140px;
  margin-bottom: 100px;
  .start1 {
    margin: 0 auto;
    width: 650px;
    font-size: 64px;
    font-weight: 900;
    color: #000000;
    line-height: 83px;
    padding-bottom: 80px;
  }
  .detail {
    width: 650px;
    font-size: 20px;
    margin: 0 auto;
    font-weight: 600;
    color: #000000;
    line-height: 45px;
  }
  img {
    width: 750px;
    height: 596px;
    margin-top: 100px;
  }
}
.w1352 {
  width: 750px;
  margin: 0 auto;
}
/*.w1300 {*/
/*    !*width: 67%;*!*/
/*    margin: 0 auto;*/
/*}*/
@keyframes showBottom {
  to {
    opacity: 1;
    transform: translateY(0px);
  }
}
@keyframes hideBottom {
  to {
    opacity: 0;
    transform: translateY(100px);
  }
}
</style>
<style lang="less" scoped>
@keyframes showLeft {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes showRight {
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
@keyframes hideLeft {
  to {
    opacity: 0;
    transform: translateX(-100px);
  }
}
@keyframes hideRight {
  to {
    opacity: 0;
    transform: translateX(100px);
  }
}
@keyframes scaleUp-animation {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.25);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes scaleDown-animation {
  0% {
    transform: scale(1.25);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.25);
  }
}
.scale {
}
.scale :hover {
  transform: rotate(7deg);
  -ms-transform: rotate(7deg); /* IE 9 */
  -moz-transform: rotate(7deg); /* Firefox */
  -webkit-transform: rotate(7deg); /* Safari 和 Chrome */
  -o-transform: rotate(7deg); /* Opera */
  color: red;
}
.intro {
  /*width: 650px;*/
  /*height: 276px;*/
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #61666b;
  line-height: 46px;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.index {
  width: 750px;
  margin: 0 auto;
  text-align: center;
  position: relative;
  .indexv-all {
    margin-top: 110px;
    width: 100%;
    height: 100%;
    overflow: hidden;

    // position: fixed;
    .indexvideo {
      overflow: hidden;
      position: relative;
      z-index: 1;
      // transform：translate（-50%,-50%);
    }
    .index_background {
      // margin-top: 110px;
      //  position: absolute;
      z-index: 9;

      text-align: center;
      img {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 99;
        // opacity: 0.5;
        width: 750px;
        height: 750px;
      }
    }
  }
  .banner {
    width: 645px;
    margin: 0 auto;
    text-align: center;
    margin-top: 880px;
    z-index: 9999;
    .title {
      margin-top: -252px;
      width: 648px;
      height: 413px;
      font-family: Poppins-Black, Poppins;
      font-size: 64px;
      font-weight: 900;
      color: #000000;
      line-height: 83px;
      -webkit-background-clip: text;
    }
    .subTitle-all {
      margin-top: 27px;
      text-align: center;
      .subTitle {
        margin: 0 auto;
        width: 630px;
        font-size: 30px;
        font-family: Poppins-Bold, Poppins;
        font-weight: bold;
        color: #000000;
        line-height: 35px;
        -webkit-background-clip: text;
        margin-bottom: 200px;
      }
      .sanTitle {
        text-align: center;
        width: 645px;
        margin-top: 20px;
        font-size: 26px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #61666b;
        line-height: 43px;
        -webkit-background-clip: text;
        .title2 {
          width: 585px;
          margin: 0 auto;
          text-align: center;
        }
        margin-bottom: 200px;
      }
    }
  }
  .team-member {
    margin-top: 240px;
    margin-bottom: 250px;
    .title-container {
      margin: 0 50px 180px;
      height: 165px;
      .title-main {
        font-size: 64px;
        font-family: Poppins-Black, Poppins;
        font-weight: 900;
        color: #000000;
        line-height: 83px;
        // span{
        //     color: #4573E7;
        // }
      }
    }
  }
}
.runDao {
  text-align: center;
  margin-top: 140px;
  margin-bottom: 100px;
  .start {
    margin: 0 auto;
    text-align: center;
    width: 650px;
    font-size: 64px;
    font-weight: 900;
    color: #000000;
    line-height: 83px;
    padding-bottom: 80px;
  }
  .bottom {
    margin: 0 auto;
    text-align: center;
    width: 480px;
    height: 90px;
    background: #111111;
    border-radius: 20px 20px 20px 20px;
    opacity: 1;
    .button {
      font-size: 28px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #ffffff;
      line-height: 90px;
    }
  }
}
.runemail {
  // border: 1px solid red;
  text-align: center;
  width: 100%;
  height: 500px;
  .emailcontent {
    width: 650px;
    margin: 0 auto;
    font-family: Poppins-Black, Poppins;

    color: #000000;
    .title {
      font-size: 64px;
      color: #000000;
      line-height: 77px;
    }
    img {
      width: 60px;
      height: 70px;
      margin-top: 30px;
      margin-bottom: 20px;
    }
    .submit {
      font-size: 40px;
      line-height: 77px;
    }
    .email {
      font-size: 30px;
      line-height: 50px;
    }
    .content {
      color: #999 !important;
      font-size: 18px;
    }
  }
}
</style>
